import configureStore from './reducers/configureStore';

export { history } from './reducers/configureStore';

export default configureStore();
